/* esm.sh - highlight.js@11.11.1/lib/languages/node-repl */
function e(a){return{name:"Node REPL",contains:[{className:"meta.prompt",starts:{end:/ |$/,starts:{end:"$",subLanguage:"javascript"}},variants:[{begin:/^>(?=[ ]|$)/},{begin:/^\.\.\.(?=[ ]|$)/}]}]}}export{e as default};
//# sourceMappingURL=node-repl.mjs.map